export function getPinArrayFromStorage() {
  return JSON.parse(localStorage.getItem('pinnedTasks')) || [];
}

export function taskHasBeenPinned(taskID) {
  let pinArray = getPinArrayFromStorage();
  return !!pinArray.filter(taskObj => taskObj.taskId === taskID).length;
}

function getDaysSinceLastTaskChange(lastModifiedDate) {
  const ONE_DAY = 1000 * 60 * 60 * 24;

  // Convert both dates to milliseconds
  const lastModDate_ms = new Date(lastModifiedDate).getTime();
  const dateNow_ms = new Date().getTime();

  // Calculate the difference in milliseconds
  const difference_ms = Math.abs(lastModDate_ms - dateNow_ms);

  // Convert back to days and return
  return Math.round(difference_ms / ONE_DAY);
}

export function relativeTimeSinceLastUpdate(lastModifiedDate) {
  const time = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const daysSinceChange = getDaysSinceLastTaskChange(lastModifiedDate);

  return time.format(-daysSinceChange, 'days');
}
